
import {Component, ComponentChildren } from 'preact';
import Woosmap from './icons/woosmap.svg';
import ArrowLeft from './icons/arrow-left.svg';
import ArrowRight from './icons/arrow-right.svg';
import CaretDown from './icons/caret-down.svg';
import CaretUp from './icons/caret-up.svg';
import CenterMarker from './icons/center-marker.svg';
import Clock from './icons/clock.svg';
import Inverse from './icons/inverse.svg';
import Close from './icons/close.svg';
import ItineraryFilled from './icons/itinerary-filled.svg';
import Stairs from './icons/stairs.svg';
import StairsThick from './icons/stairs-thick.svg';
import Marker from './icons/marker.svg';
import MarkerFilled from './icons/marker-filled.svg';
import PositionFilled from './icons/position-filled.svg';
import Phone from './icons/phone.svg';
import Share from './icons/share.svg';
import Sound from './icons/sound.svg';
import SoundMute from './icons/sound-mute.svg';
import World from './icons/world.svg';
import Itinerary from './icons/itinerary.svg';
import ItineraryOverview from './icons/itinerary-overview.svg';
import ItineraryStart from './icons/itinerary-start.svg';
import Disability from './icons/disability.svg';
import ElevatorDown from './icons/itinerary/elevator_down.svg';
import ElevatorUp from './icons/itinerary/elevator_up.svg';
import EscalatorDown from './icons/itinerary/escalator_down.svg';
import EscalatorUp from './icons/itinerary/escalator_up.svg';
import RampDown from './icons/itinerary/ramp_down.svg';
import RampUp from './icons/itinerary/ramp_up.svg';
import SlightLeftWalkPast from './icons/itinerary/slight_left_walk_past.svg';
import SlightLeft from './icons/itinerary/slight_left.svg';
import SlightRightWalkPast from './icons/itinerary/slight_right_walk_past.svg';
import SlightRight from './icons/itinerary/slight_right.svg';
import StairsDown from './icons/itinerary/stairs_down.svg';
import StairsUp from './icons/itinerary/stairs_up.svg';
import Travelator from './icons/itinerary/travelator.svg';
import TurnLeftWalkPast from './icons/itinerary/turn_left_walk_past.svg';
import TurnLeft from './icons/itinerary/turn_left.svg';
import TurnRightWalkPast from './icons/itinerary/turn_right_walk_past.svg';
import TurnRight from './icons/itinerary/turn_right.svg';
import WalkStraightDistance from './icons/itinerary/walk_straight_distance.svg';
import WalkStraightPast from './icons/itinerary/walk_straight_walk_past.svg';
import WalkStraight from './icons/itinerary/walk_straight.svg';
import NavElevatorDown from './icons/itinerary/nav-elevator_down.svg';
import NavElevatorUp from './icons/itinerary/nav-elevator_up.svg';
import NavEscalatorDown from './icons/itinerary/nav-escalator_down.svg';
import NavEscalatorUp from './icons/itinerary/nav-escalator_up.svg';
import NavRampDown from './icons/itinerary/nav-ramp_down.svg';
import NavRampUp from './icons/itinerary/nav-ramp_up.svg';
import NavSlightLeftWalkPast from './icons/itinerary/nav-slight_left_walk_past.svg';
import NavSlightLeft from './icons/itinerary/nav-slight_left.svg';
import NavSlightRightWalkPast from './icons/itinerary/nav-slight_right_walk_past.svg';
import NavSlightRight from './icons/itinerary/nav-slight_right.svg';
import NavStairsDown from './icons/itinerary/nav-stairs_down.svg';
import NavStairsUp from './icons/itinerary/nav-stairs_up.svg';
import NavTravelator from './icons/itinerary/nav-travelator.svg';
import NavTurnLeftWalkPast from './icons/itinerary/nav-turn_left_walk_past.svg';
import NavTurnLeft from './icons/itinerary/nav-turn_left.svg';
import NavTurnRightWalkPast from './icons/itinerary/nav-turn_right_walk_past.svg';
import NavTurnRight from './icons/itinerary/nav-turn_right.svg';
import NavWalkStraightDistance from './icons/itinerary/nav-walk_straight_distance.svg';
import NavWalkStraightPast from './icons/itinerary/nav-walk_straight_walk_past.svg';
import NavWalkStraight from './icons/itinerary/nav-walk_straight.svg';
import NavWalkStraightSmall from './icons/itinerary/nav-walk_straight_small.svg';
import NavigationArrow from './icons/itinerary/navigation-arrow.svg';
import Minus from "./icons/minus.svg";
import Plus from "./icons/plus.svg";
import Edit from "./icons/edit.svg";
import Time from "./icons/time.svg";
import Distance from "./icons/distance.svg";
import Stops from "./icons/stops.svg";
import DownArrow from "./icons/down-arrow.svg";
import Search from "./icons/search.svg";
import BigClose from "./icons/BigClose.svg";
import Tour from "./icons/tour.svg";
import DoubleArrowLeft from './icons/double-arrow-left.svg';
import DoubleArrowRight from './icons/double-arrow-right.svg';

const Icons = {
    'arrow-left': ArrowLeft,
    'arrow-right': ArrowRight,
    'caret-down': CaretDown,
    'caret-up': CaretUp,
    'center-marker': CenterMarker,
    clock: Clock,
    inverse: Inverse,
    close: Close,
    'itinerary-filled': ItineraryFilled,
    stairs: Stairs,
    'stairs-thick': StairsThick,
    marker: Marker,
    'marker-filled': MarkerFilled,
    'position-filled': PositionFilled,
    phone: Phone,
    share: Share,
    sound: Sound,
    'sound-mute': SoundMute,
    world: World,
    itinerary: Itinerary,
    "itinerary-overview": ItineraryOverview,
    "itinerary-start": ItineraryStart,
    disability: Disability,
    'elevator_down': ElevatorDown,
    'elevator_up': ElevatorUp,
    'escalator_down': EscalatorDown,
    'escalator_up': EscalatorUp,
    'ramp_down': RampDown,
    'ramp_up': RampUp,
    'slight_left_walk_past': SlightLeftWalkPast,
    'slight_left': SlightLeft,
    'slight_right_walk_past': SlightRightWalkPast,
    'slight_right': SlightRight,
    'stairs_down': StairsDown,
    'stairs_up': StairsUp,
    'travelator': Travelator,
    'turn_left_walk_past': TurnLeftWalkPast,
    'turn_left': TurnLeft,
    'turn_right_walk_past': TurnRightWalkPast,
    'turn_right': TurnRight,
    'walk_straight_distance': WalkStraightDistance,
    'walk_straight_walk_past': WalkStraightPast,
    'walk_straight': WalkStraight,
    'nav-elevator_down': NavElevatorDown,
    'nav-elevator_up': NavElevatorUp,
    'nav-escalator_down': NavEscalatorDown,
    'nav-escalator_up': NavEscalatorUp,
    'nav-ramp_down': NavRampDown,
    'nav-ramp_up': NavRampUp,
    'nav-slight_left_walk_past': NavSlightLeftWalkPast,
    'nav-slight_left': NavSlightLeft,
    'nav-slight_right_walk_past': NavSlightRightWalkPast,
    'nav-slight_right': NavSlightRight,
    'nav-stairs_down': NavStairsDown,
    'nav-stairs_up': NavStairsUp,
    'nav-travelator': NavTravelator,
    'nav-turn_left_walk_past': NavTurnLeftWalkPast,
    'nav-turn_left': NavTurnLeft,
    'nav-turn_right_walk_past': NavTurnRightWalkPast,
    'nav-turn_right': NavTurnRight,
    'nav-walk_straight_distance': NavWalkStraightDistance,
    'nav-walk_straight_walk_past': NavWalkStraightPast,
    'nav-walk_straight': NavWalkStraight,
    'nav-walk_straight_small': NavWalkStraightSmall,
    'navigation-arrow': NavigationArrow,
    'minus': Minus,
    'plus' : Plus,
    'edit': Edit,
    'time': Time,
    'distance': Distance,
    'stops': Stops,
    'down-arrow': DownArrow,
    'search': Search,
    'big-close': BigClose,
    'tour': Tour,
    'double-arrow-left': DoubleArrowLeft,
    'double-arrow-right': DoubleArrowRight,
};
/**
 * @private
 */
type Props = {
    size?: number,
    className?: string,
    title?: string,
    testId?: string,
    icon: string,
};
type State = {};


/**
 * @private
 */
export default class Icon extends Component<Props, State> {
    render(): ComponentChildren {
        const {
            icon, size, className, title, testId
        } = this.props;

        const IconComponent = Object.keys(Icons).includes(icon) ? (Icons as any)[icon] : Woosmap;

        return (
            <IconComponent
                className={`icon ${className || ''}`}
                data-testid={`${testId || ''}-${icon}`}
                width={size}
                height={size}
                title={title}
            />
        );
    }
}
Icon.defaultProps = {
    size: 24,
    className: null,
    title: null,
    testId: 'icon',
};
